import FormCampusSelect from './FormCampusSelect'
export default {
  extends: FormCampusSelect,
  computed: {
    mergedConfig () {
      return {
        searchable: true,
        options: [],
        ...this.config,
        // the formCampusesSelect field is ONLY mutli select
        // and if you are looking for the single select option,
        // you should use the formCampusSelect input
        multiple: true,

      }
    },
  },
}
